{
  "version": 1,
  "asset_id": "5fd7a6fe-7f67-48b1-8a1c-833625fb144c",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/5fd7a6fe-7f67-48b1-8a1c-833625fb144c/clip-img_2225-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/5fd7a6fe-7f67-48b1-8a1c-833625fb144c/clip-img_2225-poster-sm.webp",
  "original_filename": "clip-img_2225-poster-sm.webp",
  "size": 18456,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:41Z"
}
